import { Box, Text } from "@chakra-ui/react";

interface PreviewMessageProps {
  message: string;
  headers: string[];
  csvFirstLine: Record<string, any>;
}

export function PreviewMessage(props: PreviewMessageProps) {
  let replacedMessage = getPreviewMessage(props);

  return (
    <Box
      bg="white"
      color="gray.800"
      p={3}
      borderRadius="md"
      position="relative"
      maxW="100%"
      fontFamily="Segoe UI, Arial, Helvetica, sans-serif"
      fontSize="14px"
      lineHeight="1.4"
      border="1px solid"
      borderColor="gray.100"
    >
      <Text
        whiteSpace="pre-wrap"
        fontSize="14px"
        fontWeight="400"
        m={0}
        p={0}
        color="gray.700"
        opacity={0.6}
      >
        {replacedMessage}
      </Text>
    </Box>
  );
}

function getPreviewMessage({
  csvFirstLine,
  headers,
  message,
}: PreviewMessageProps) {
  let replacedMessage = message;

  for (const header of headers) {
    const placeholder = `Preview da mensagem`;
    const value =
      csvFirstLine[header] !== undefined ? csvFirstLine[header] : placeholder;
    replacedMessage = replacedMessage.replaceAll(`#${header}#`, value);
  }
  return replacedMessage;
}
